const classes = {
  focus: 'is-focused',
};

const selectors = {
  inPageLink: '[data-skip-content]',
  linkesWithOnlyHash: 'a[href="#"]',
};

class Accessibility {
  constructor() {
    this.init();
  }

  init() {
    this.a11y = window.theme.a11y;

    // DOM Elements
    this.html = document.documentElement;
    this.body = document.body;
    this.inPageLink = document.querySelector(selectors.inPageLink);
    this.linkesWithOnlyHash = document.querySelectorAll(selectors.linkesWithOnlyHash);

    // A11Y init methods
    this.a11y.focusHash();
    this.a11y.bindInPageLinks();

    // Events
    this.clickEvents();
    this.focusEvents();
  }

  /**
   * Clicked events accessibility
   *
   * @return  {Void}
   */

  clickEvents() {
    if (this.inPageLink) {
      this.inPageLink.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }

    if (this.linkesWithOnlyHash) {
      this.linkesWithOnlyHash.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
        });
      });
    }
  }

  /**
   * Focus events
   *
   * @return  {Void}
   */

  focusEvents() {
    let usingKeyboard = false;
    let mouseDownTime = 0;

    document.addEventListener('mousedown', () => {
      usingKeyboard = false;
      mouseDownTime = Date.now();
      this.body.classList.remove(classes.focus);
    });

    document.addEventListener('keydown', () => {
      usingKeyboard = true;
    });

    document.addEventListener('focusin', () => {
      // Add class if using keyboard (Tab) or no recent mouse interaction (VoiceOver)
      if (usingKeyboard || Date.now() - mouseDownTime > 1000) {
        this.body.classList.add(classes.focus);
      }
    });
  }
}

window.a11y = new Accessibility();
